<template>
    <FilterBody
        v-model:search-model-value="customerSuccessManagerFilterProperties.searchTerm"
        :label="t('projectclient.projectlist.topbar.filters.customersuccessmanager.header')"
        :display-search="true"
        :search-placeholder="t('projectclient.projectlist.topbar.filters.customersuccessmanager.search.placeholder')"
        :items="customerSuccessManagerFilterProperties.displayedResults"
        :selected-items="screenSizeSearchParams.customerSuccessManagers"
        :pending="customerSuccessManagerFilterProperties.pending"
        :display-show-more="customerSuccessManagerFilterProperties.hasMoreToShow && !customerSuccessManagerFilterProperties.isSearchActive"
        @reset="projectListFiltersStore.handleResetCategory('customerSuccessManagers')"
        @check:item="handleCheckBoxChange"
        @show-more="handleShowMore"
    >
        <template #item="{item}">
            {{
                `${item.label === 'deleted.account.firstName' ? t('deleted.account.firstName') : item.label} ${
                    item.count > 0 ? `(${item.count})` : ''
                }`
            }}
        </template>
    </FilterBody>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import type {TypedAggregationResource} from '@common/composables';
    import {useScreenSizeStore} from '@common/stores';
    import {useProjectsListStore, useProjectsListFiltersStore} from '@features/projects-list/stores';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import FilterBody from '../wrappers/FilterBody.vue';

    const {t} = useTranslation();

    const screenSizeStore = useScreenSizeStore();
    const {isSmallScreen} = storeToRefs(screenSizeStore);

    const projectListStore = useProjectsListStore();
    const {searchParams} = storeToRefs(projectListStore);

    const projectListFiltersStore = useProjectsListFiltersStore();
    const {temporarySearchParams, customerSuccessManagerFilterProperties} = storeToRefs(projectListFiltersStore);

    const screenSizeSearchParams = computed(() => {
        if (isSmallScreen.value) {
            return temporarySearchParams.value;
        } else {
            return searchParams.value;
        }
    });

    function handleCheckBoxChange(item: TypedAggregationResource<string>) {
        projectListFiltersStore.handleUpdateCategory('customerSuccessManagers', item.value);
    }

    function handleShowMore() {
        customerSuccessManagerFilterProperties.value.resultsSize += 6;
    }
</script>
